import { icon, Icon } from '../lib/fa-icons.js';
import { render, Component } from "preact";
import Widget from "./base.js";
import onProfileLoad, { onRefresh as onProfileRefresh } from "tpm-lib/profile";

export class HeaderAccount extends Widget {
	constructor(props) {
		super(props);
		this.state = { profile: {}, requesting: true };
	}

	componentWillMount() {
		this.state = {
			username: null,
			membership: null,
			requesting: true,
			dropdownActive: false,
		};
		this.ajaxRequest();
		onProfileRefresh(this.ajaxSignIn.bind(this));

		this.setIdentCookie = this.setIdentCookie.bind(this);
		this.signOut = this.signOut.bind(this);
		this.toggleDropdown = this.toggleDropdown.bind(this);

		const self = this;
		window.addEventListener("click", (e) => {
			if (!self.state.dropdownActive) return;
			if (e.target.closest(".HeaderAccount")) return;
			self.toggleDropdown();
		});
	}

	ajaxRequest() {
		onProfileLoad().then(
			this.ajaxSignIn.bind(this),
			this.ajaxSignIn.bind(this)
		);
	}

	ajaxSignIn(profile) {
		this.setState({
			profile: profile,
			username: profile.email,
			membership: profile.membership,
			requesting: false,
		});
	}

	signOut() {
		if (this.props.sign_out_url) {
			window.location.href = this.props.sign_out_url;
			return;
		}
		fetch(`https://accounts.${document.location.hostname}/signout`, {
			method: "POST",
			credentials: "include",
		})
			.then((r) => {
				window.location.reload();
			})
			.catch((r) => {
				window.location.reload();
			});
	}

	setIdentCookie() {
		const now = Date.now();
		const exp = new Date(now + 1000 * 60 * 60 * 24);
		document.cookie = `wp-ident=${now}; path=/; expires=${exp.toUTCString()}`;
	}

	toggleDropdown() {
		this.setState(
			{
				dropdownActive: !this.state.dropdownActive,
			},
			() => {
				this.toggleBodyClass();
			}
		);
	}

	toggleBodyClass() {
		if (this.state.dropdownActive) {
			document.body.classList.add("tpm-dropdown-active");
		} else document.body.classList.remove("tpm-dropdown-active");
	}

	username() {
		return this.state.optimistic ? "Profile" : this.state.username;
	}

	badge(red = false) {
		const { profile } = this.state;

		let badge;
		if (red) {
			badge = "badge-prime-white.svg";
			if (profile.isAdfree()) badge = "badge-adfree-white.svg";
			if (profile.isInside()) badge = "badge-inside-white.svg";
		} else {
			badge = "TPMRedes_PrimeLogo_Red.svg";
			if (profile.isAdfree()) badge = "adfree-logo-icon-2.svg";
			if (profile.isInside()) badge = "inside-logo-icon.svg";
		}

		if (profile.isStaff()) badge = "staff-account-icon.svg";

		return (
			<img
				src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/logo/${badge}`}
				alt="Account Options"
			/>
		);
	}

	joinBtn(text = "Join") {
		const utm = `utm_source=on_site&utm_medium=header_button_${this.props.utm_medium}&utm_campaign=memberships`;
		return (
			<a
				class={`Button --red js_header-button`}
				href={`https://${document.location.hostname}/memberships?${utm}`}
				onClick={this.setIdentCookie}
			>
				<span>{text}</span>
			</a>
		);
	}

	signOutButton() {
		return (
			<div class="TrayMenu__SignOut">
				<div class="Button --empty-black" onClick={this.signOut}>
					Sign Out
				</div>
			</div>
		);
	}

	footerSection() {
		return (
			<div class="TrayMenu__Footer">
				<div class="TrayMenu__HelpContact">
					<a href={`https://${document.location.hostname}/faq`}>Help</a>
					<a href={`https://${document.location.hostname}/contact`}>Contact</a>
				</div>
				<div class="TrayMenu__Copyright">
					{`© ${new Date().getFullYear()} TPM MEDIA LLC. ALL RIGHTS RESERVED.`}
				</div>
			</div>
		);
	}

	isMember() {
		return (
			this.state.profile &&
			this.state.profile.hasOwnProperty("membership") && // not sure why this is needed
			this.state.profile.isPrime()
		);
	}

	member() {
		const self = this;
		const membershipName = () => {
			if (self.state.profile.isStaff()) return "TPM Staff";
			if (self.state.profile.isInside()) return "Inside Member";
			if (self.state.profile.isAdfree()) return "Prime Ad Free Member";
			return "Prime Member";
		};

		return (
			<div
				class={`HeaderAccount --prime ${
					this.props.mode === "mobile" ? "--mobile" : "--desktop"
				} `}
			>
				<div class="flex-container">
					<div
						onClick={this.toggleDropdown}
						class={`HeaderAccount__ToggleDropdown ${
							this.state.dropdownActive ? "active" : ""
						}`}
					>
						<div class="HeaderAccount__User">
							{this.badge(this.props.red)}
							<span class="desktop-only">Account</span>
							<span class="mobile-only"><Icon name="user" style="sharp-solid" /></span>
						</div>
					</div>
				</div>
				<div
					class={`TrayMenu --right ${
						this.state.dropdownActive ? "active" : ""
					} `}
				>
					<div class="TrayMenu__Header">
						<div
							class="TrayMenu__Close --right dropdown-control"
							onClick={this.toggleDropdown}
						>
							<Icon name="xmark" style="light" />
						</div>
					</div>
					<div class="TrayMenu__UserDetails">
						<div class="TrayMenu__Username">{this.username()}</div>
						<div class="TrayMenu__MembershipLevel">{membershipName()}</div>
					</div>
					<div class="TrayMenu__Nav --always-active">
						<ul>
							<li>
								<a href={`https://accounts.${document.domain}/account`}>
									<div class="TrayMenu__LiFlex">
										<div>Account</div>
										<Icon name="user" style="sharp-solid" />
									</div>
								</a>
							</li>
							<li>
								<a
									href={`https://forums.${document.location.hostname}/session/sso?return_path=/`}
								>
									<div class="TrayMenu__LiFlex">
										<div>The Hive</div>
										<img
											style={{
												margin: "0",
												width: "30px",
												height: "30px",
												transform: "translateY(2px)",
												margin: "0 0 0 0",
											}}
											src={`${document.location.protocol}//${document.location.hostname}/wp-content/themes/tpm25/assets/images/icons/hive.svg`}
										/>
									</div>
								</a>
							</li>
							<li>
								<a href={`https://${document.location.hostname}/new-to-you`}>
									<div class="TrayMenu__LiFlex">
										<div>New To You</div>
										<Icon name="newspaper" style="light" />
									</div>
								</a>
							</li>

							<li>
								<a
									href={`https://accounts.${document.location.hostname}/account#feeds`}
								>
									<div class="TrayMenu__LiFlex">
										<div>RSS Feeds</div>
										<Icon name="rss" style="solid" />
									</div>
								</a>
							</li>
						</ul>
					</div>
					{this.signOutButton()}
					{this.footerSection()}
				</div>
			</div>
		);
	}

	basic() {
		return (
			<div
				class={`HeaderAccount --basic ${
					this.props.mode === "desktop" ? "--desktop" : "--mobile"
				}`}
			>
				<div class="HeaderAccount__User" onClick={this.toggleDropdown}>
					<span class="desktop-only">Account</span>
					<Icon name="user" style="sharp-solid" />
				</div>
				<div
					class={`TrayMenu --right ${
						this.state.dropdownActive ? "active" : ""
					} `}
				>
					<div class="TrayMenu__Header">
						<div
							class="TrayMenu__Close --right dropdown-control"
							onClick={this.toggleDropdown}
						>
							<Icon name="xmark" style="light" />
						</div>
					</div>
					<div class="TrayMenu__UserDetails">
						<div class="TrayMenu__Username">{this.username()}</div>
						<div class="TrayMenu__MembershipLevel">Basic Account</div>
					</div>
					<div class="TrayMenu__Nav --always-active">
						<ul>
							<li>
								<a
									href={`https://accounts.${document.location.hostname}/account`}
								>
									<div class="TrayMenu__LiFlex">
										<div>Account</div>
										<Icon name="user" style="sharp-solid" />
									</div>
								</a>
							</li>
						</ul>
					</div>
					<div class="TrayMenu__Join">{this.joinBtn("Become A Member")}</div>
					{this.signOutButton()}
					{this.footerSection()}
				</div>
			</div>
		);
	}

	signedOut() {
		return (
			<div
				class={`HeaderAccount --signed-out ${
					this.props.mode === "mobile" ? "--mobile" : ""
				}`}
			>
				<a
					class="HeaderAccount__SignIn"
					href={`https://accounts.${document.location.hostname}/signin?referer=${document.location.href}`}
					onClick={this.setIdentCookie}
				>
					Sign In
				</a>
				{this.joinBtn()}
			</div>
		);
	}

	render() {
		if (this.state.requesting) return null;

		//sign in member
		if (this.isMember()) return this.member();
		// signed in, basic
		else if (this.state.username) return this.basic();
		//not signed in
		else return this.signedOut();
	}
}
